import { RouteRecordRaw } from "vue-router";
import { guardInvoiceAccess, guardEInvoicesAccess, guardInvoiceSettingsAccess } from "../navigationsGuards/guardInvoice";

const MODULE_NAME = 'INVOICES';
const MODULE_ID = 19;

const evaluationRoutes: Array<RouteRecordRaw> = [
    {
        path: '/invoice',
        meta: {
            requiresAuth: true,
        },
        beforeEnter: [],
        children: [
            {
                path: '',
                name: 'InvoiceList',
                component: () => import('@/views/invoice/invoiceList.vue'),
                beforeEnter: [guardInvoiceAccess],
            },
            {
                path: 'project',
                beforeEnter: [],
                children: [
                    {
                        path: '',
                        name: 'InvoiceProjects',
                        component: () => import('@/views/invoice/Projects.vue'),
                        beforeEnter: [guardInvoiceAccess],
                    },
                    {
                        path: ':projectId',
                        name: 'InvoiceProject',
                        component: () => import('@/views/invoice/ProjectInvoiceDetails.vue'),

                        beforeEnter: [],
                    },
                ]
            },
            {
                path: 'to-be-invoiced',
                name: 'InvoiceToBeInvoiced',
                component: () => import('@/views/invoice/ToBeInvoiced.vue'),
                beforeEnter: [guardInvoiceAccess],
            },
            {
                path: 'e-invoices',
                name: 'InvoiceEInvoices',
                component: () => import('@/views/invoice/EInvoices.vue'),
                beforeEnter: [guardEInvoicesAccess],
            },
            {
                path: 'settings',
                name: 'InvoiceSettings',
                component: () => import('@/views/invoice/Settings.vue'),
                beforeEnter: [guardInvoiceSettingsAccess],
            },
            {
                path: 'purchases',
                name: 'InvoicePurchases',
                component: () => import('@/views/invoice/Purchases.vue'),
                beforeEnter: [guardInvoiceAccess],
            },

        ]

    },
]

export default evaluationRoutes.map(route => ({ ...route, meta: { ...route.meta, moduleName: MODULE_NAME, moduleId: MODULE_ID } }));
